export function noop(): void {
    // noop
}

export async function noopPromise(): Promise<void> {
    // noop
}
